module.exports = __webpack_public_path__ + "img/1.2d2a0d3d.png";